var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { COLORS } from "../../../constants";
import { DateIndicator } from "./components";
var Timeline = function (_a) {
    var dates = _a.dates, timezoneId = _a.timezoneId, stacked = _a.stacked, _b = _a.timelineBgColor, timelineBgColor = _b === void 0 ? COLORS.WHITE : _b, singleDateColumn = _a.singleDateColumn, _c = _a.size, size = _c === void 0 ? "medium" : _c, hideDivider = _a.hideDivider;
    return (_jsx(Stack, __assign({ direction: "row", position: "relative" }, { children: _jsx(Stack, __assign({ width: "100%", position: "relative" }, { children: dates.map(function (itm, idx) { return (_jsx(DateIndicator, { timelineBgColor: timelineBgColor, dateItm: itm, singleDateColumn: singleDateColumn, timezoneId: timezoneId, stacked: stacked, last: idx === dates.length - 1, hideDivider: hideDivider, size: size }, "".concat(itm.title, "-").concat(idx))); }) })) })));
};
export default Timeline;
